import { render } from "./PlaceholderElement.vue?vue&type=template&id=3f339311"
import script from "./PlaceholderElement.vue?vue&type=script&lang=js"
export * from "./PlaceholderElement.vue?vue&type=script&lang=js"

import "./PlaceholderElement.vue?vue&type=style&index=0&id=3f339311&lang=scss"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__